// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1-AXf","choiceBoxes":"toolbarselects_choiceBoxes__3E-U7","simpleField":"toolbarselects_simpleField__1_EL6"};